import { IEmployeeSkills } from '../../../shared/interfaces/employeeSkills/IEmployeeSkills';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { SKILL_URL } from '../../../utils/api/endpoints';

export const AdminEmployeeSkillsService = {
  get: (params: IPagination): Promise<IBaseModel<IEmployeeSkills[]>> =>
    requests.get(SKILL_URL, params),
  getSingle: (id: number): Promise<IEmployeeSkills> =>
    requests.get(`${SKILL_URL}/${id}`),
  create: (payload: IEmployeeSkills): Promise<IEmployeeSkills> =>
    requests.post(SKILL_URL, payload),
  update: (payload: IEmployeeSkills, id: number): Promise<IEmployeeSkills> =>
    requests.put(`${SKILL_URL}/${id}`, payload),
  delete: (id: number): Promise<IEmployeeSkills> =>
    requests.delete(`${SKILL_URL}/${id}`),
};
